import React, { useState, useContext, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import Switch from "react-switch";
import makeAnimated from "react-select/animated";

//pages & includes
import PayrollSidebar from "../../PayrollSidebar";
//functions
import {
  _t,
  getCookie,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from 'react-icons/md';

import { PayrollContext } from "../../../../../../contexts/Payroll";
import CustomSpinLoader from "../../../../../components/CustomSpinLoader";

const Designation = () => {
    const { t } = useTranslation();
    const history = useHistory();
  
    //finance context
    const {
        loading,
        setLoading,
        dataPaginating,
        setDataPaginating,
        //employee
        designations,
        setDesignations,
        designationForSearch,
        setDesignationForSearch,
        setPaginatedDesignation,

    } = useContext(PayrollContext);
    
    //search result
    let [searchedDesignation, setSearchedDesignation] = useState({
      list: null,
      searched: false,
    });

    //delete account here
    const handleDeleteAccount = (slug) => {
        setLoading(true);
        const coa1Url = BASE_URL + `/settings/delete-coa-level1/${slug}`;
        return axios
        .get(coa1Url, {
            headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
            setDesignations(res.data[0])
            setDesignationForSearch(res.data[1]);
            setSearchedDesignation({
            ...searchedDesignation,
            list: res.data[1],
            });
            setLoading(false);
            toast.success(`${_t(t("Designation has been deleted successfully"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
            });
        })
        .catch(() => {
            setLoading(false);
            toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
            });
        });
    };

    //search account here
    const handleSearch = (e) => {
      let searchInput = e.target.value.toLowerCase();
      if (searchInput.length === 0) {
        setSearchedDesignation({ ...searchedDesignation, searched: false });
      } else {
        let searchedList = designationForSearch.filter((item) => {
          let lowerCaseItemName = item.name.toLowerCase();
          let lowerCaseItemCode = item.code.toLowerCase();
          return lowerCaseItemName.includes(searchInput) ||
          lowerCaseItemCode.includes(searchInput)
        });
        setSearchedDesignation({
          ...searchedDesignation,
          list: searchedList,
          searched: true,
        });
      }
    };
  
    //delete confirmation modal of account
    const handleDeleteConfirmation = (slug) => {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="card card-body">
              <h1>{_t(t("Are you sure?"))}</h1>
              <p className="text-center">{_t(t("You want to delete this?"))}</p>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-primary rounded"
                  onClick={() => {
                    handleDeleteAccount(slug);
                    onClose();
                  }}
                >
                  {_t(t("Yes, delete it!"))}
                </button>
                <button className="btn btn-success ml-2 px-3 rounded" onClick={onClose}>
                  {_t(t("No"))}
                </button>
              </div>
            </div>
          );
        },
      });
    };
  
    return (
      <>
        <Helmet>
          <title>{_t(t("Designation"))}</title>
        </Helmet>
  
        {/* main body */}
        <main id="main" data-simplebar>
          <div className="container-fluid">
            <div className="row t-mt-10 gx-2">
              {/* left Sidebar */}
              <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                <PayrollSidebar />
              </div>
              {/* left Sidebar ends */}
  
              {/* Rightbar contents */}
              <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                <div className="t-bg-white">
                  <div className="fk-scroll--pos-table-menu" data-simplebar>
                    <div className="t-pl-15 t-pr-15">
                        <div key="fragment3">
                          {/* next page data spin loading */}
                          <CustomSpinLoader loading={dataPaginating}/>
                          {/* spin loading ends */}
  
                          <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                            <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                              <ul className="t-list fk-breadcrumb">
                                <li className="fk-breadcrumb__list">
                                  <span className="t-link fk-breadcrumb__link text-capitalize">
                                    {!searchedDesignation.searched
                                      ? _t(t("Designation"))
                                      : _t(t("Search Result"))}
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6 col-lg-7">
                              <div className="row gx-3 align-items-center">
                                {/* Search group */}
                                <div className="col-md-9 t-mb-15 mb-md-0">
                                  <div className="input-group">
                                    <div className="form-file">
                                      <input
                                        type="text"
                                        className="form-control border-0 form-control--light-1 rounded-left"
                                        placeholder={_t(t("Search")) + ".."}
                                        onChange={handleSearch}
                                      />
                                    </div>
                                    <button
                                      className="btn btn-primary rounded-right"
                                      type="button"
                                    >
                                      <i
                                        className="fa fa-search"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                  </div>
                                </div>
  
                                {/* Add group modal trigger button */}
                                <div className="col-md-3 text-md-right">
                                  <NavLink
                                    className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                    to="/dashboard/payroll/designation-add"
                                  >
                                    {_t(t("add new"))}
                                  </NavLink>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Table */}
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover min-table-height">
                              <thead className="align-middle">
                                <tr>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("S/L"))}
                                  </th>
  
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Code"))}
                                  </th>
  
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Name"))}
                                  </th>
  
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Action"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                                {!searchedDesignation.searched
                                  ? [
                                      designations && [
                                        designations.data.length === 0 ? (
                                          <tr className="align-middle">
                                            <td
                                              scope="row"
                                              colSpan="6"
                                              className="xsm-text align-middle text-center"
                                            >
                                              {_t(t("No data available"))}
                                            </td>
                                          </tr>
                                        ) : (
                                          designations.data.map((item, index) => {
                                            return (
                                              <tr
                                                className="align-middle"
                                                key={index}
                                              >
                                                <th
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {index +
                                                    1 +
                                                    (designations.current_page -
                                                      1) *
                                                      designations.per_page}
                                                </th>
                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.code}
                                                </td>
  
                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.name}
                                                </td>
                                                <td className="xsm-text text-capitalize align-middle text-center">                                                  
                                                    <NavLink
                                                        className="btn btn-primary ml-2 rounded-sm del-btn"
                                                        to={`/dashboard/payroll/designation-edit/${item.id}`}                                             
                                                    >                                                    
                                                        <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>                                                    
                                                    </NavLink>
                                                    <button
                                                    className="btn btn-danger ml-2 rounded-sm del-btn"
                                                    onClick={() => {
                                                        handleDeleteConfirmation(item.id);
                                                    }}                                                   
                                                    >                                                    
                                                        <MdDelete className="del-icon" />                                                    
                                                    </button>
                                                </td>                                            
                                              </tr>
                                            );
                                          })
                                        ),
                                      ],
                                    ]
                                  : [
                                      /* searched data, logic === haveData*/
                                      searchedDesignation && [
                                        searchedDesignation.list.length === 0 ? (
                                          <tr className="align-middle">
                                            <td
                                              scope="row"
                                              colSpan="6"
                                              className="xsm-text align-middle text-center"
                                            >
                                              {_t(t("No data available"))}
                                            </td>
                                          </tr>
                                        ) : (
                                          searchedDesignation.list.map(
                                            (item, index) => {
                                              return (
                                                <tr
                                                className="align-middle"
                                                key={index}
                                              >
                                                <th
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {index +
                                                    1 +
                                                    (designations.current_page -
                                                      1) *
                                                      designations.per_page}
                                                </th>
  
                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.code}
                                                </td>
  
                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.name}
                                                </td>
                                                <td className="xsm-text text-capitalize align-middle text-center">                                                  
                                                    <NavLink
                                                        className="btn btn-primary ml-2 rounded-sm del-btn"
                                                        to={`/dashboard/payroll/designations-edit/${item.id}`}                                             
                                                    >                                                    
                                                        <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>                                                    
                                                    </NavLink>
                                                    <button
                                                    className="btn btn-danger ml-2 rounded-sm del-btn"
                                                    onClick={() => {
                                                        handleDeleteConfirmation(item.id);
                                                    }}                                                   
                                                    >                                                    
                                                        <MdDelete className="del-icon" />                                                    
                                                    </button>
                                                </td>
                                              </tr>
                                              );
                                            }
                                          )
                                        ),
                                      ],
                                    ]}
                              </tbody>
                            </table>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
  
                {/* pagination loading effect */}
                {loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchedDesignation.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(designations, setPaginatedDesignation)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(designations)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    setSearchedDesignation({
                                      ...searchedDesignation,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searchedDesignation,
                                    designationForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
                
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </main>
        {/* main body ends */}
      </>
  )
}

export default Designation
